class SecondLoading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ローディング中はスクロールを無効化
    function noscroll(e){
      e.preventDefault();
    }
    document.addEventListener('touchmove', noscroll, {passive: false});
    document.addEventListener('wheel', noscroll, {passive: false});

    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    // scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');

    const loadingBg = '.js-loading-bg';
    const loadingLogo = '.js-loading-logo';

    if(isMobile()){
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          opacity: 0
        })
        .to(loadingLogo,1 ,{
          scale: 0.92,
          opacity: 0,
        },'<')
      }, 1300);
    }else{
      setTimeout(() => {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
  
        const mvTl = gsap.timeline()
        .to(loadingBg, 1, {
          x: '-90%',
          y: '21%',
        })
        .to(loadingLogo,0.5 ,{
          width: '12rem',
          opacity: 0,
        },'<')
      }, 1300);
    }
    setTimeout(() => {
      $(".c-second-loading").fadeOut(500);
      // スクロールを許可
      document.removeEventListener('touchmove', noscroll);
      document.removeEventListener('wheel', noscroll);
    },2500)
  }
}